import { DialogActions, Dialog, DialogContent, DialogTitle, IconButton, styled, Typography, CircularProgress, Tooltip, Select, MenuItem, InputBase, Snackbar, Slide, TextField, useTheme, useMediaQuery } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useFormik } from 'formik';
import * as React from 'react';  
import { useState } from 'react';
import { AddCircleOutlineOutlined, HelpOutline, AddCircle } from '@material-ui/icons';
import { Button, Form } from 'react-bootstrap';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import * as Yup from "yup";
import CloseIcon from '@material-ui/icons/Close';
import { FillContext } from '../../../../hooks/ContextStore';
import { useContext } from 'react';
import {
    CreateAnimals,
    CreateBankAccount,
    CreateBonus,
    CreateBrokerage,
    CreateBusiness,
    CreateCashOnHand,
    CreateChildren,
    CreateClub,
    CreateEquitableClaims,
    CreateFederalTax,
    CreateInsurance,
    CreateLiabilities,
    CreateMoney,
    CreateMsc,
    CreateOtherLiabilities,
    CreatePersonalProperty,
    CreatePropertyHeld,
    CreateRealProperty,
    CreateRetirment,
    CreateStocks,
    CreateTravelAward,
    CreateVehicle
} from '../Service/Request';
import { useHistory } from "react-router-dom";
import { useMemo } from 'react';
import { GetClientCaseId } from '../../../../Functions/General';
import { Alert } from '@material-ui/lab';



const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: (theme.vars ?? theme).palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
}); 


export default function CreateModal(props) {
    const { isOpen, handleClose } = props;
    
    const client_case_id = GetClientCaseId();
    const [valueDate, setValueDate] = useState(new Date());    
    const [date, setDate] = useState(new Date());
    const [fill, setFill] = useContext(FillContext);
    const [createIsLoad, setCreateIsLoad] = useState(false);
    const history = useHistory();
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseSuccess, setResponseSuccess] = useState(false);
    const category = window.location.pathname;  
    const isBankAccounts = category === '/estatev2/bank-accounts'; 

const validationSchema = Yup.object({
  description: isBankAccounts
    ? Yup.string()
        .matches(/^\d+$/, 'Bank Account must be numbers only')
        .required('Bank Account is required')
    : Yup.string().required('Description is required'),

  value: Yup.number().notRequired(),
  position: Yup.string().required('Position is required'),
  debt: Yup.number().notRequired(), 
  type: isBankAccounts
    ? Yup.string().required('Bank Type is required')
    : Yup.string().notRequired().nullable(),
  bankName: isBankAccounts
    ? Yup.string().required('Bank Name is required')
    : Yup.string().notRequired().nullable(),

  clientSP: Yup.number().notRequired(),
  spouseSP: Yup.number().notRequired(),
}); 

    const handleChange = (date) => {
        let date_dt = new Date(date);
        let new_date = new Date(date_dt.getFullYear(), date_dt.getMonth(), date_dt.getDate(), '10', '56', '00')
        setDate(new_date);
    }; 

    const handleSnackbarClose = () => {
        setSnackBarOpen(false);
    };
    const handleDate = (date) => {
        let date_dt = new Date(date).toLocaleDateString('en-CA')
        setValueDate(date_dt);
    }; 

        const updateFillWithKeys = (categoryLink) => {
        const keys = estateFillKeys[categoryLink] || [];
        if (keys.length === 0) return;
        // Create a new fill object copying current fill
        const newFill = { ...fill };

        keys.forEach((key) => {
            newFill[key] = 1;
        });
        setFill(newFill);
        //this will open the estate page with the selected category
        history.push(categoryLink);
    };

    const estateList = useMemo(() => [
            {
                name: "Real Property",
                function: CreateRealProperty,
                condition: fill?.real_property || fill?.mineral_interest,
                link: "/estatev2/real-estate",
            },
            // {
            //     name: "Cash On Hand",
            //     function: CreateCashOnHand,
            //     condition: fill?.cash || fill?.equivalents,
            //     link: "/estatev2/cash-onhand",
            // },
            {
                name: "Bank Accounts",
                function: CreateBankAccount,
                condition: fill?.bank_account,
                link: "/estatev2/bank-accounts",
            },
            {
                name: "Brokerage",
                function: CreateBrokerage,
                condition: fill?.brokerage,
                link: "/estatev2/brokerage",
            },
            {
                name: "Stocks",
                function: CreateStocks,
                condition: fill?.public_stocks || fill?.employee_stock_option || fill?.employee_stock,
                link: "/estatev2/stocks",
            },
            {
                name: "Bonuses",
                function: CreateBonus,
                condition: fill?.bonuses,
                link: "/estatev2/bonuses",
            },
            {
                name: "Business Interests",
                function: CreateBusiness,
                condition: fill?.business_interest,
                link: "/estatev2/business-interests",
            },
            {
                name: "Retirement Accts & Benefits",
                function: CreateRetirment,
                condition:
                    fill?.contribution_plan || fill?.benefit_plan || fill?.ira_sep || fill?.military_benefit ||
                    fill?.non_qualified_plan || fill?.government_benefits || fill?.compensation_benefits || fill?.union_benefits,
                link: "/estatev2/retirement-benefits",
            },
            {
                name: "Insurance and Annuities",
                function: CreateInsurance,
                condition: fill?.life_insurance || fill?.annuities,
                link: "/estatev2/insurance-annuities",
            },
            {
                name: "Other Asset Types/Miscellaneous",
                function: CreateMsc,
                condition:
                    fill?.intellectual_property || fill?.safe_deposit || fill?.storage_facilities ||
                    fill?.contingent_assets || fill?.other_assets || fill?.precious_metals,
                link: "/estatev2/miscellaneous-property",
            },
            {
                name: "Vehicles",
                function: CreateVehicle,
                condition: fill?.vehicles,
                link: "/estatev2/vehicles",
            },
            {
                name: "Money Owed",
                function: CreateMoney,
                condition: fill?.money_owned,
                link: "/estatev2/money-owed",
            },
            {
                name: "Personal Property",
                function: CreatePersonalProperty,
                condition: fill?.client_possession || fill?.spouse_possession || fill?.spouse_both,
                link: "/estatev2/personal-property",
            },
            {
                name: "Animals",
                function: CreateAnimals,
                condition: fill?.pets || fill?.livestock,
                link: "/estatev2/livestock",
            },
            {
                name: "Club Memberships",
                function: CreateClub,
                condition: fill?.club_membership,
                link: "/estatev2/club-memberships",
            },
            {
                name: "Travel Award Benefits",
                function: CreateTravelAward,
                condition: fill?.travel_award_benefit,
                link: "/estatev2/travel",
            },
            {
                name: "Credit Cards & Revolving Debt",
                function: CreateLiabilities,
                condition:
                    fill?.credit_card || fill?.federal_liabilities || fill?.contingent_liabilities ||
                    fill?.amount_owned_to_attorney_or_professionals || fill?.other_liabilities,
                link: "/estatev2/credit-cards",
            },
            {
                name: "Federal and State Taxes",
                function: CreateFederalTax,
                condition:
                    fill?.credit_card || fill?.federal_liabilities || fill?.contingent_liabilities ||
                    fill?.amount_owned_to_attorney_or_professionals || fill?.other_liabilities,
                link: "/estatev2/federal-tax",
            },
            {
                name: "Other Debt",
                function: CreateOtherLiabilities,
                condition:
                    fill?.credit_card || fill?.federal_liabilities || fill?.contingent_liabilities ||
                    fill?.amount_owned_to_attorney_or_professionals || fill?.other_liabilities,
                link: "/estatev2/other-debt",
            },
            {
                name: "Children's Assets",
                function: CreateChildren,
                condition: fill?.children_assets,
                link: "/estatev2/child-accounts",
            },
            {
                name: "Property Held in Trust",
                function: CreatePropertyHeld,
                condition: fill?.asset_held_for_either_party || fill?.asset_held_for_benefit,
                link: "/estatev2/property-trust",
            },
            {
                name: "Equitable Claims",
                function: CreateEquitableClaims,
                condition: fill?.equitable_for_community_estate || fill?.equitable_for_separate_estate,
                link: "/estatev2/equitable-claims",
            },
        ], [fill]);

    const formik = useFormik({
        initialValues: {
            description: '',
            value: '',
            debt: '',
            account_number: '',
            bankName: '',
            clientSP: '',
            spouseSP: '',
            date: date,
            category: '/estatev2/real-estate',
            type: '',
            position: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values['date'] = date;
            setCreateIsLoad(true);
            const selected = estateList.find(estate => estate.link === category);
            if (selected) {
                var response = await selected.function(values, client_case_id);
                if (response && response.status === 200) {
                    setResponseSuccess(true);
                }else {
                    setResponseSuccess(false);
                }

                setSnackBarOpen(true);

                formik.resetForm({ values: { ...formik.initialValues, category: category } }); //jsut to stay same assets based on scott
                
                setCreateIsLoad(false);
                history.push('/estatev2');
                updateFillWithKeys(selected.link);
            }
        },
    });

    const estateFillKeys = {
        "/estatev2/real-estate": ["real_property", "mineral_interest"],
        "/estatev2/cash-onhand": ["cash", "equivalents"],
        "/estatev2/bank-accounts": ["bank_account"],
        "/estatev2/brokerage": ["brokerage"],
        "/estatev2/stocks": ["public_stocks", "employee_stock_option", "employee_stock"],
        "/estatev2/bonuses": ["bonuses"],
        "/estatev2/business-interests": ["business_interest"],
        "/estatev2/retirement-benefits": [
            "contribution_plan",
            "benefit_plan",
            "ira_sep",
            "military_benefit",
            "non_qualified_plan",
            "government_benefits",
            "compensation_benefits",
            "union_benefits",
        ],
        "/estatev2/insurance-annuities": ["life_insurance", "annuities"],
        "/estatev2/miscellaneous-property": [
            "intellectual_property",
            "safe_deposit",
            "storage_facilities",
            "contingent_assets",
            "other_assets",
            "precious_metals",
        ],
        "/estatev2/vehicles": ["vehicles"],
        "/estatev2/money-owed": ["money_owned"],
        "/estatev2/personal-property": ["client_possession", "spouse_possession", "spouse_both"],
        "/estatev2/livestock": ["pets", "livestock"],
        "/estatev2/club-memberships": ["club_membership"],
        "/estatev2/travel": ["travel_award_benefit"],
        "/estatev2/credit-cards": [
            "credit_card",
            "federal_liabilities",
            "contingent_liabilities",
            "amount_owned_to_attorney_or_professionals",
            "other_liabilities",
        ],
        "/estatev2/federal-tax": [
            "credit_card",
            "federal_liabilities",
            "contingent_liabilities",
            "amount_owned_to_attorney_or_professionals",
            "other_liabilities",
        ],
        "/estatev2/other-debt": [
            "credit_card",
            "federal_liabilities",
            "contingent_liabilities",
            "amount_owned_to_attorney_or_professionals",
            "other_liabilities",
        ],
        "/estatev2/child-accounts": ["children_assets"],
        "/estatev2/property-trust": ["asset_held_for_either_party", "asset_held_for_benefit"],
        "/estatev2/equitable-claims": ["equitable_for_community_estate", "equitable_for_separate_estate"],
    };

    const toolTipHandler = (property) => {
        switch (property) {
            case 'description':
                switch (category) {
                    case '/estatev2/bank-accounts':
                        return "Enter the last 4 digits of the account number.";
                    case '/estatev2/credit-cards':
                        return "Enter the last 4 digits of the credit card number.";
                    case '/estatev2/personal-property':
                        return `You typically should not list EVERY item of personal property, but instead estimate the total value of groups of property, such as "Furniture in marital residence." An exception to this may be a particularly valuable item such as a particularly valuable painting or item of jewelry. When in doubt, ask your lawyer.`;
                    default:
                        return "Enter a description for this asset.";
                }
            case 'value':
                switch (category) {
                    case '/estatev2/other-debt':
                    case '/estatev2/credit-cards':
                        return "Enter the total debt amount if applicable.";
                    case '/estatev2/business-interests':
                        return "You will often not know the value of a business. If you have a recent appraisal, or an estimate, please provide that and after you have clicked " + " click the notes icon next to the asset and explain how you arrived at the value.";
                    case '/estatev2/insurance-annuities':
                        return "For annuities, this estimated value is often provided on your regular statements. For life insurance, please provide the cash value (if any). This is not the amount the insurance would pay in the event of death, but the value you would receive if you cashed the policy out today (typically not applicable with TERM life policies).";
                    case '/estatev2/personal-property':
                        return "For physical property, the value will typically be the market value (what you could sell the present item for on the open market), as opposed to what the item would be worth new. When in doubt, ask your lawyer.";
                    default:
                        return "Enter the value of this asset.";
                }
            case 'debt':
                switch (category) {
                    case '/estatev2/real-estate':
                        return "This is the balance of the first lien mortgage on the property. If there is a second lien on the property, list the second lien balance in the drop down below after you have clicked the " + " button to enter the asset.";
                    case '/estatev2/bank-accounts':
                        return "It would be rare for a bank account to have a debt associated with it. Place a value here only if the account is overdrawn.";
                    case '/estatev2/brokerage':
                        return "This will typically be applicable only if you have purchased stock on margin, participated in short selling, or other less common activities. When in doubt, ask your lawyer. ";
                    case '/estatev2/retirement-benefits':
                        return "If you have borrowed against your retirement, please put your loan balance here.";
                    default:
                        return "Any debt that is specifically attached and/or creating a lien on this particular asset. For many assets, this will not be applicable. ";
                }
            case 'bankName':
                return "Select the type of bank account.";
            case 'type':
                return "Select the type of bank name.";
            case 'position':
                return "This is the person who has physical possession of the asset, control of the asset, or in the case of a financial account, the person whose name is on the account. ";
            case 'clientSP':
                return "This is the value of your separate property interest in the asset. If the asset is wholly your separate property, this should equal the total value of the asset. You will need to ask your lawyer about the separate property laws in your state. ";
            case 'spouseSP':
                return "This is the value of your separate property interest in the asset. If the asset is wholly your separate property, this should equal the total value of the asset. You will need to ask your lawyer about the separate property laws in your state. ";
            default:
                return `Enter ${property} for this asset.`;
        }
    }

    const labelHandler = (property) => {
        switch (property) {
            case 'description':
                switch (category) {
                    case '/estatev2/bank-accounts':
                    case '/estatev2/credit-cards':
                    case '/estatev2/retirement-benefits':
                        return "Acct#(last 4 digits)";
                    case '/estatev2/real-estate':
                        return "Address";
                    case '/estatev2/stocks':
                        return "Name of Stock";
                    case '/estatev2/business-interests':
                        return "Business Name";
                    case '/estatev2/credit-cards':
                        return "Bank/CC name";
                    case '/estatev2/brokerage':
                        return "Financial Institution";
                    default:
                        return "Description";
                }
            case 'value':
                switch (category) {
                    case '/estatev2/other-debt':
                    case '/estatev2/credit-cards':
                        return "Debt (if Applicable)";
                    case '/estatev2/federal-tax':
                        return "Overpayment (if applicable)";
                    default:
                        return "Value";
                }  
            case 'debt':
                switch (category) {
                    case '/estatev2/real-estate':
                        return "Mortgage Balance";
                    case '/estatev2/federal-tax':
                        return "Amount Owed";
                    default:
                        return "Debt (if Applicable)";
                }
            case 'clientSP':
                return "Client SP";
            case 'spouseSP':
                return "Spouse SP";
            default:
                return property.charAt(0).toUpperCase() + property.slice(1);
        }
    }

    const positions = [
        "Husband",
        "Wife",
        "Joint",
        "Client",
        "Spouse",
        "Third Party",
        "Other"
    ];

      const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  }; 
  const theme = useTheme();
  const isWide = useMediaQuery('(min-width:1500px)');
  return (
    <>  
      <Dialog
            maxWidth="lg"
            // onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            fullWidth
            keepMounted
            disableBackdropClick   
            disableEscapeKeyDown   
            TransitionComponent={Transition}
            TransitionProps={{ mountOnEnter: true, unmountOnExit: false }} // 👈 important
            PaperProps={{
                style: {
                position: 'fixed',
                top: '12%',
                margin: 0,
                ...(isWide && {
                    left: 'calc(50% + 120px)',
                    transform: 'translateX(-50%)',
                }),
                },
            }}
            > 
        <div className='d-flex justify-content-between align-items-center px-4 pt-3'>
            <div>
                 <h6>{estateList.find(e => e.link === category)?.name }</h6>
            </div>
            <div className='mb-2'>
                <Button
                    aria-label="close"
                    onClick={()=> {
                        handleClose();
                        formik.resetForm({ values: { ...formik.initialValues, category: category } });
                    }}
                    size='medium'
                    // variant='text'
                    >
                    Close
                </Button>
            </div>
        </div>
        <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework d-flex flex-column w-100"> 
        <DialogContent dividers> 
            <div className="row px-5">
                <div className='col-md-11 row'> 
                    {
                        category === '/estatev2/bank-accounts' && (
                            <div className='col-md-4'>
                                <Form.Label>{labelHandler('Bank Name')}</Form.Label>
                                <Tooltip title={toolTipHandler('bankName')} className='mr-1 ml-3'>
                                    <HelpOutline fontSize="small" />
                                </Tooltip> 
                                <input
                                    type="text"
                                    name="bankName"
                                    className={`form-control form-control-solid h-auto`}
                                    {...formik.getFieldProps("bankName")}
                                />
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                    {formik.errors.bankName ? formik.errors.bankName : ""}
                                    </div>
                                </div>  
                            </div>
                        )
                    }  
                    <div className={`${category === '/estatev2/bank-accounts' ? 'col-md-2' : 'col-md-4'}`}>
                        <Form.Label>{labelHandler('description')}</Form.Label>
                        <Tooltip title={toolTipHandler('description')} className='mr-1 ml-3'>
                            <HelpOutline fontSize="small" />
                        </Tooltip> 
                        <input
                            type="text"
                            name="description"
                            className={`form-control form-control-solid h-auto`}
                            {...formik.getFieldProps("description")}
                        />
                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                            {formik.errors.description ? formik.errors.description : ""}
                            </div>
                        </div>  
                    </div>
                    <div className='col-md-2'>
                        <Form.Label>{labelHandler('value')}</Form.Label>
                        <Tooltip title={toolTipHandler('value')} className='mr-1 ml-3'>
                            <HelpOutline fontSize="small" />
                        </Tooltip> 
                        <input
                            type="text"
                            name="value"
                            className={`form-control form-control-solid h-auto`}
                            {...formik.getFieldProps("value")}
                        />
                        <div className="fv-plugins-message-container">
                            <div value="fv-help-block">
                            {formik.errors.value ? formik.errors.value : ""}
                            </div>
                        </div>  
                    </div>
                    <div className='col-md-2'>
                        <Form.Label>Value as of</Form.Label>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/DD/yyyy" 
                            id="date-picker-inline"
                            value={valueDate}
                            onChange={handleDate}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}/>
                        </MuiPickersUtilsProvider>
                    </div> 
                    {
                        category === '/estatev2/bank-accounts' && (
                            <div className='col-md-2'>
                                <Form.Label>Type</Form.Label>
                                <Tooltip title={toolTipHandler('type')} className='mr-1 ml-3'>
                                    <HelpOutline fontSize="small" />
                                </Tooltip> 
                                    <Select
                                name="type"
                                labelId="demo-customized-select-label"
                                id="demo-customized-select" 
                                value={formik.values.type}   
                                onChange={formik.handleChange}
                                displayEmpty
                                style={{ width: '100%' }} 
                                renderValue={(selected) => {
                                    if (!selected) {
                                    return <span style={{ color: '#999' }}>Bank Type</span>;
                                    }
                                    return selected;
                                }}
                                input={<BootstrapInput />}
                            >                                
                                    <MenuItem value="checking">checking</MenuItem>
                                    <MenuItem value="savings">savings</MenuItem>
                                    <MenuItem value="money market">money market</MenuItem>
                                    <MenuItem value="certificate of deposit">certificate of deposit</MenuItem>
                            </Select> 
                            </div>
                        )
                    }  
                    {
                    category !== '/estatev2/bank-accounts' && (
                        <div className='col-md-2'>
                            <Form.Label>{labelHandler('debt')}</Form.Label>
                            <Tooltip title={toolTipHandler('debt')} className='mr-1 ml-3'>
                                <HelpOutline fontSize="small" />
                            </Tooltip> 
                            <input
                                type="text"
                                name="debt"
                                className={`form-control form-control-solid h-auto`}
                                {...formik.getFieldProps("debt")}
                            />
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                {formik.errors.debt ? formik.errors.debt : ""}
                                </div>
                            </div>  
                        </div>
                        )
                    }
                    <div className='col-md-2'>
                        <Form.Label>Name/Control of</Form.Label>
                        <Tooltip title={toolTipHandler('position')} className='mr-1 ml-3'>
                            <HelpOutline fontSize="small" />
                        </Tooltip> 
                        <Select
                            name="position"
                            labelId="demo-customized-select-label"
                            id="demo-customized-select" 
                            value={formik.values.position}   
                            onChange={formik.handleChange}
                            displayEmpty
                            style={{ width: '100%' }}  
                            input={<BootstrapInput />}
                            renderValue={(selected) => { 
                                if (!selected) {
                                return <span style={{ color: '#999' }}>Name/Control of</span>;
                                }
                                return selected;
                            }}
                            >                                
                                {positions.map((position) => (
                                    <MenuItem key={position} value={position}>
                                        {position}
                                    </MenuItem>
                                ))}
                        </Select> 
                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                            {formik.errors.position ? formik.errors.position : ""}
                            </div>
                        </div>  
                    </div>
                    <div className='col-md-2'>
                        <Form.Label>{labelHandler('clientSP')}</Form.Label>
                        <Tooltip title={toolTipHandler('clientSP')} className='mr-1 ml-3'>
                            <HelpOutline fontSize="small" />
                        </Tooltip> 
                        <input
                            type="text"
                            name="clientSP"
                            className={`form-control form-control-solid h-auto`}
                            {...formik.getFieldProps("clientSP")}
                        />
                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                            {formik.errors.clientSP ? formik.errors.clientSP : ""}
                            </div>
                        </div>  
                    </div>
                    <div className='col-md-2'>
                        <Form.Label>{labelHandler('spouseSP')}</Form.Label>
                        <Tooltip title={toolTipHandler('spouseSP')} className='mr-1 ml-3'>
                            <HelpOutline fontSize="small" />
                        </Tooltip> 
                        <input
                            type="text"
                            name="spouseSP"
                            className={`form-control form-control-solid h-auto`}
                            {...formik.getFieldProps("spouseSP")}
                        />
                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                            {formik.errors.spouseSP ? formik.errors.spouseSP : ""}
                            </div>
                        </div>  
                    </div>
                </div>  
                <div className='col-md-1 d-flex align-items-center'>
                    <div className="w-100 d-flex align-items-center justify-content-center">
                        {
                        createIsLoad ? (
                            <CircularProgress color='secondary'/>
                        ) : (
                            <IconButton 
                                aria-label="delete" 
                                size="large"  
                                color="secondary"  
                                type="submit">
                                <AddCircle fontSize="large" />
                            </IconButton>
                        )
                        }
                    </div>
                </div>
            </div>
             
        </DialogContent> 
          </form>
      </Dialog> 
    <Snackbar
        open={snackBarOpen} 
        autoHideDuration={2000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right' }}>
        <Alert
            onClose={handleSnackbarClose}
            severity={responseSuccess ? "success" : "error"}
            variant="filled"
            sx={{ width: '100%' }}
        >
            {responseSuccess ? "Created successfully" : "There was an error, please try again."}
        </Alert>
    </Snackbar>
    </>
    
  );
}